import { IContextualMenuProps, CommandButton, CompoundButton, Dialog, DialogContent, DialogType, DialogFooter } from '@fluentui/react';
import React from 'react';
import App from '../../App';
import { IUserService, Services } from '../../services';
import styles from './AppLayout.module.scss';
import { AnnouncementMessageBar } from './AnnouncementMessageBar';
import { UserServiceProvider } from '../../services/userService';
import { LanguageContext } from '../../LanguageContext';

interface IAppLayoutProps {

}

interface IAppLayoutState {
  showIntro: boolean;
}

export class AppLayout extends React.Component<IAppLayoutProps, IAppLayoutState> {
  private userService: IUserService;
  static contextType = LanguageContext;
  context: React.ContextType<typeof LanguageContext>;

  constructor(props: IAppLayoutProps) {
    super(props);

    this.userService = Services.UserService.Initialize(new UserServiceProvider());

    this.state =
    {
      showIntro: this.userService.IsFirstTimeForUser()
    }
  }

  public render(): React.ReactElement<{}> {
    const t = this.context?.t ?? ((key: string) => key);

    let userMenuProps: IContextualMenuProps = {
      items: [
        {
          key: 'changePassword',
          text: t('appLayout.changePassword'),
          iconProps: { iconName: 'PasswordField' },
          href: "/skift-adgangskode"
        },
        {
          key: 'signOut',
          text: t('appLayout.logout'),
          iconProps: { iconName: 'SignOut' },
          onClick: (ev) => {
            this.userService.SignOut();
          }
        },
      ]
    };

  if (App.IsUserInRole("DL") || App.IsUserInRole("Purchaser") || App.IsUserInRole("Admin")) {
      userMenuProps.items.splice(1, 0, {
        key: 'assignments',
        text: t('appLayout.taskOverview'),
        iconProps: { iconName: 'TaskManager' },
        href: "/"
      });

      userMenuProps.items.splice(2, 0, {
        key: 'userAdministration',
        text: t('appLayout.userAdministration'),
        iconProps: { iconName: 'Contact' },
        href: "/brugeradministration"
      });

      // Only show 'Information til DL'ere' for DL role
      if (App.IsUserInRole("DL")) {
        userMenuProps.items.splice(3, 0, {
          key: 'linkInfoPageInternally',
          text: t('appLayout.informationForDL'),
          iconProps: { iconName: 'BookAnswers' },
          href: "https://ddh4.sharepoint.com/sites/Intranet/SitePages/Flisportalen.aspx",
          target: "_blank"
        });
      }
    }

    if (App.IsUserInRole("Admin")) {
      userMenuProps.items.splice(4, 0, {
        key: 'announcements',
        text: t('appLayout.announcements'),
        iconProps: { iconName: 'Message' },
        href: "/beskeder"
      });
    }

    return (
      <div className={styles.layoutContainer}>
        <div className={styles.header}>
          <div className={styles.headerContent}>

            <a href="/" className={styles.logoContainer}><img alt={t('appLayout.dalgasLogoAlt')} className={styles.logo} style={{ padding: 15 }} src="/images/ds-logo-wide-RGB-neg.png?rev=1.0" /></a>
            {App.IsAuthenticated &&
              <React.Fragment>
                <CommandButton className={styles.userMenu} text={App.Username} menuProps={userMenuProps} />

                {this.state.showIntro &&

                  <Dialog hidden={false} minWidth={window.innerWidth * 0.6} dialogContentProps={{ title: t('appLayout.supplierForDalgas'), isMultiline: true, type: DialogType.largeHeader }}>
                    <DialogContent>
                      <div>
                        <h4>{t('appLayout.introTitle')}</h4>

                        <div>{t('appLayout.introText')}</div>
                        <br />
                        <h4>{t('appLayout.documentationTitle')}</h4>
                        <div>
                          <ul>
                            <li>{t('appLayout.documentationText')}</li>
                            <li>{t('appLayout.documentationText2')}</li>
                          </ul>
                          <p>{t('appLayout.documentationText3')}</p>
                        </div>
                      </div>
                    </DialogContent>
                    <DialogFooter>
                      <CompoundButton primary iconProps={{ iconName: "CheckMark" }} secondaryText={t('appLayout.startUsingPortal')} onClick={() => { this.onDismissFirstTimeIntro(); }}>{t('appLayout.iHaveUnderstood')}</CompoundButton>
                    </DialogFooter>
                  </Dialog>
                }
              </React.Fragment>
            }

          </div>
        </div>
        <div className={styles.container}>
          {App.IsAuthenticated && <AnnouncementMessageBar />}

          <div className={styles.headerimage}>
            <img alt={t('appLayout.dalgasBackgroundAlt')} src="/images/topbanner.jpg?rev=1.0" />
            <div className={styles.overlayImageContainer}>
              <div className={styles.overlayImageRow}>
                <img className={styles.fifth3} src="/images/hs-element-lavender-02-rgb.png" />
              </div>
              <div className={styles.overlayImageRow}>
                <img className={styles.fifth2} src="/images/hs-element-lavender-02-rgb.png" />
                <img className={styles.fifth1} src="/images/hs-element-lavender-01-rgb.png" />
              </div>
            </div>
          </div>
          <div className={styles.appName}>{t('appLayout.portalName')}</div>
          <div className={styles.contentWrapper}>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }

  private onDismissFirstTimeIntro() {
    this.userService.dismissFirstTimeIntro();

    this.setState({ showIntro: false });
  }
}
